import { ArpyRequirementFile } from "src/app/models/arpyRequirementFile";
import { GraphQLArpyRequirementFileOutput } from "../models/output/graphql-arpy-file-output";

export function convertGraphqlArpyFileToArpyRequirementFile(input: GraphQLArpyRequirementFileOutput): ArpyRequirementFile {
  if (!input) return undefined;

  return {
    id: input.id,
    fileName: input.fileName,
    baseFileName: input.baseFileName,
    version: input.version,
    isLatest: input.isLatest,
    fileSize: input.fileSize,
    contentHash: input.contentHash,
    s3Key: input.s3Key,
    description: input.description,
    sourceType: input.sourceType as ArpyRequirementFile['sourceType'],
    createdAt: input.createdAt,
    createdBy: input.createdBy,
    updatedAt: input.updatedAt,
    isActive: input.isActive
  }
}
